import type { ExpenseItemDesciption } from "@src/__generated__/graphql";

export function toExpenseDescriptionOptions(
  descriptions: ExpenseItemDesciption[],
) {
  return descriptions.map((description) => ({
    value: description.id,
    label: description.title,
    isDisabled: !!description.deleted_at,
  }));
}
